import {baseApiInstanceWithRefresh} from "./baseApiInstance";

/**
 * Обновляет тип ИНС слайда и перемещает SVS-файл в соответствующую директорию на сервере.
 * Должен вызываться перед отправкой слайда на AI-разметку.
 */
export const setSlideTissue = (slideId, tissue) =>
    baseApiInstanceWithRefresh
        .patch(`/api/slide/${slideId}/set-tissue/`, {tissue})
        .then(r => r.data);
